import React from 'react'

import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'

import { ShowWhatsHere } from 'drawer/tabs/info/WhatsHereUtils'

import WhatsHereMenuItem from './WhatsHereMenuItem'

interface WhatsAroundMenuItemProps {
  closeMenu?: () => void
  currentTarget: any
}

interface WhatsAroundMenuItemState {
  bufferSize: string
  bufferSizeHelperText: string
  expanded: boolean
}

class WhatsAroundMenuItem extends React.Component<WhatsAroundMenuItemProps, WhatsAroundMenuItemState> {
  constructor (props: WhatsAroundMenuItemProps) {
    super(props)

    this.state = {
      bufferSize: '0',
      bufferSizeHelperText: '',
      expanded: false
    }
  }

  render () {
    const { currentTarget, closeMenu } = this.props
    const { bufferSize, bufferSizeHelperText, expanded } = this.state

    const featureCollection = currentTarget?.featureCollection ?? currentTarget
    const featureType = featureCollection?.features?.[0]?.geometry?.type || ''

    const bufferMenuOnClick = () => {
      this.setState({ expanded: !expanded })
    }

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const bufferSize = event.target.value
      let bufferSizeHelperText = ''

      // If value entered is non-numeric, show error message and disable select button
      if (bufferSize === '' || isNaN(Number(bufferSize))) {
        bufferSizeHelperText = 'Please enter a valid number'
      // If value is negative and the feature is not a polygon, show error message and disable select button
      } else if (Number(bufferSize) < 0 && !featureType.match(/polygon/i)) {
        bufferSizeHelperText = 'Negative distance for a point or line'
      }

      this.setState({
        bufferSize,
        bufferSizeHelperText
      })
    }

    const bufferSelectOnClick = (event: React.ChangeEvent<HTMLFormElement>) => {
      // Prevent form submission
      event.preventDefault()

      ShowWhatsHere(featureCollection, Number(bufferSize))
      console.debug('bufferSelectOnClick', bufferSize, 'featureCollection', featureCollection)
      if (closeMenu) {
        closeMenu()
      }
    }

    const bufferForm = (
      <Stack sx={{ padding: '15px' }} spacing={1}>
        <TextField
          autoFocus
          error={Boolean(bufferSizeHelperText)}
          helperText={bufferSizeHelperText}
          label='Distance/buffer (m)'
          onChange={handleChange}
          value={bufferSize}
        />
        <Button
          disabled={Boolean(bufferSizeHelperText)}
          type='submit'
        >
          Select
        </Button>
      </Stack>
    )

    return (
      <form onSubmit={bufferSelectOnClick} >
        <WhatsHereMenuItem menuItemType='whatsAroundThis' onClick={bufferMenuOnClick} />
        {expanded && bufferForm}
      </form>
    )
  }
}

export default WhatsAroundMenuItem
